var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkBarMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    viewBox: "0 0 312 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ranking-bar-gradient-dark-mode-filtered",
    y1: 3,
    x2: "100%",
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#922a2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#963233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9b3a38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9f423d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a34a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#a75247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ac5a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#b0624f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#b36a54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b87259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#bc795d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c08061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#c58968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#c9916c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#cd9870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#d1a175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d6a97a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d9b07f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#dfb882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e2c187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e0c186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#dec286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#dbc285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#d8c285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d6c284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d3c382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#d0c382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#cec380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#cbc380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#c7c480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#c6c47f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c3c37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c1c47d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#bdc37b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#bac47a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#b8c478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#b5c479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#b3c477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#b0c577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adc576"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBarMuted);
export default __webpack_public_path__ + "static/media/DarkBarMuted.7e0c9b65.svg";
export { ForwardRef as ReactComponent };